import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PlatformOverview = () => {
  const platforms = [
    {
      name: 'n8n',
      tagline: 'For Security & Control',
      description: 'The open-source choice for technical teams. Self-hostable, secure, and infinitely customizable via JavaScript.',
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80",
      alt: 'n8n workflow dashboard',
      features: ['Self-hosted option (GDPR compliant)', 'Execution control via API', 'Custom Node.js functions', 'Git Version Control'],
      icon: 'Workflow',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    },
    {
      name: 'Make.com',
      tagline: 'For Speed & Ease',
      description: 'The visual automation standard. Drag, drop, and connect 1,500+ apps in minutes without managing servers.',
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80",
      alt: 'Make.com scenario builder',
      features: ['Visual Scenario Builder', 'Instant Webhooks', 'Built-in Data Store', 'Error Handlers (Try/Catch)'],
      icon: 'Zap',
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    }
  ];

  return (
    <section className="py-20 bg-background relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl font-bold text-foreground">
            Two Powerful Platforms, <span className="text-primary">One Expert Team</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We are certified experts in both major automation platforms. We pick the right tool for your specific business case.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 relative">
          
          {/* VS Badge (Desktop Center) */}
          <div className="hidden lg:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 w-16 h-16 bg-background rounded-full border-4 border-muted items-center justify-center shadow-xl">
            <span className="font-black text-muted-foreground">VS</span>
          </div>

          {platforms.map((platform, index) => (
            <div
              key={index}
              className="flex flex-col bg-card rounded-2xl border border-border shadow-sm hover:shadow-2xl transition-all duration-300 overflow-hidden group"
            >
              {/* Image Header */}
              <div className="relative h-56 overflow-hidden">
                <Image
                  src={platform.image}
                  alt={platform.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent opacity-90" />
                
                <div className="absolute bottom-6 left-6 flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${platform.bgColor}`}>
                    <Icon name={platform.icon} size={24} className={platform.color} />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-foreground">{platform.name}</h3>
                    <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">{platform.tagline}</span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-8 flex-1 flex flex-col">
                <p className="text-muted-foreground leading-relaxed mb-8 flex-1">
                  {platform.description}
                </p>

                <div className="bg-muted/30 rounded-xl p-6 border border-border/50">
                  <h4 className="text-xs font-bold text-foreground uppercase tracking-wide mb-4 flex items-center gap-2">
                    <Icon name="CheckCircle2" size={14} className="text-primary" /> Key Capabilities
                  </h4>
                  <ul className="space-y-3">
                    {platform.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3 text-sm text-muted-foreground">
                         <div className={`mt-1.5 w-1.5 h-1.5 rounded-full ${index === 0 ? 'bg-orange-500' : 'bg-purple-500'}`} />
                         {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformOverview;